module.exports = __webpack_public_path__ + "img/home-photo.77665e13.jpg";